/* eslint-disable import/prefer-default-export */

/**
 * Check if a string is a reference to a K_NODE
 *
 * @param {string} string
 * @returns {boolean}
 */
export const isKNode = string => string.startsWith('K_NODE;');
